import { ILocationForList } from "@services/locations";
import { Buffer } from "buffer";

export const LOCATIONS_POS_KEY = `loc|user:`;

export const saveLocationsPos = (locs: ILocationForList[], key: string) => {
  //console.log("SET LOCPOS", `${POOL_KEY}${key}`, locs);
  const ids = locs.map((p) => p.Id).join(",");
  const endcoded = Buffer.from(ids, "utf-8").toString("base64");
  localStorage.setItem(`${LOCATIONS_POS_KEY}${key}`, endcoded);
};

export const getSavedLocationsPositions = (key: string) => {
  //console.log("GET LOCPOS", `${POOL_KEY}${key}`);
  const base64 = localStorage.getItem(`${LOCATIONS_POS_KEY}${key}`);
  if (!base64) return;
  const result = Buffer.from(base64, "base64").toString().split(",");
  //console.log("GET LOCPOS RESULT", `${POOL_KEY}${key}`, result);
  return result;
};

export const checkingLocationsPositions = (
  key: string,
  locs?: ILocationForList[]
) => {
  if (!locs || !locs.length) return [];
  const savedPositions = getSavedLocationsPositions(key);
  if (!savedPositions) return locs;

  let filtered = [...locs];
  const currentPositions: ILocationForList[] = [];

  savedPositions?.forEach((sp) => {
    const index = filtered.findIndex((item) => `${item.Id}` === `${sp}`);
    if (index === -1) return;
    currentPositions.push(filtered[index]);
    filtered = [...filtered.slice(0, index), ...filtered.slice(index + 1)];
  });

  // возвращаем все что мы запушили в верном порядке + то, что осталось в настройках
  // это на случай если добавлены новыйе настройки, а порядок не сохранен
  //console.log("CHECK LOCPOS 3", currentPositions, filtered);
  return [...currentPositions, ...filtered];
};
